import React from 'react'
import PropTypes from 'prop-types'
import { Form, Checkbox, Row, Col, Input } from 'antd'

const OptionalMessageInWidget = ({
  showWarning,
  warning,
  messageInWidgetOptions,
  onOptionSelect,
  handleTextInputChange,
  css,
  formCss,
}) => {
  return (
    <Form.Item label="Optional Message in Widget" className={formCss.itemLabel}>
      {showWarning && <div style={{ color: 'red' }}>{warning}</div>}
      <Row>
        {Object.keys(messageInWidgetOptions).map(option => (
          <Col key={option}>
            <Checkbox
              value={option}
              onChange={e => onOptionSelect(e, 'messageOptions')}
              checked={
                option === 'hideMessageOnMapRow'
                  ? !messageInWidgetOptions[option].value
                  : messageInWidgetOptions[option].value
              }
              disabled={
                (option === 'hideMessageOnMapRow' ||
                  option === 'showPhoneMessageOnDropdown') &&
                !messageInWidgetOptions.contactPhoneNumber.value &&
                !messageInWidgetOptions.customMessage.value
              }
              className={formCss.label}
            >
              {messageInWidgetOptions[option].label}
            </Checkbox>
            {messageInWidgetOptions[option].textInput !== undefined && (
              <Form.Item className={css.extraQuestionField} style={{ width: '100%' }}>
                <Input
                  type="text"
                  value={messageInWidgetOptions[option].textInput}
                  onChange={e => handleTextInputChange(e, option)}
                  placeholder={messageInWidgetOptions[option].placeholder}
                />
              </Form.Item>
            )}
          </Col>
        ))}
      </Row>
    </Form.Item>
  )
}

OptionalMessageInWidget.propTypes = {
  showWarning: PropTypes.bool.isRequired,
  warning: PropTypes.string.isRequired,
  messageInWidgetOptions: PropTypes.object.isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  handleTextInputChange: PropTypes.func.isRequired,
  css: PropTypes.object.isRequired,
  formCss: PropTypes.object.isRequired,
}

export default OptionalMessageInWidget



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/OptionalMessageInWidget.js